module.exports = __webpack_public_path__ + "static/media/pencil-ruler.770bc587.svg";